import React, {Component} from 'react';
//import Notifications, {notify} from 'react-notify-toast'
import Notifications, {notify} from '../components/custom_notify/notify'

export default class Toast extends Component {

	constructor(props) {
		super(props)
		this.state = {
			timeout:5000,
		}
	}

	componentWillUnmount = () => {
		notify.hide()
	}

	componentDidMount = () => {
		const {
			notifyMessage,
			callback
		} = this.props
		const {
			timeout
		} = this.state
		notify.show(notifyMessage,null,timeout,callback)
	}

	render () {
		return(
			<div onClick={notify.hide}>
				<Notifications />
			</div>	
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/toast.js